module.exports = __webpack_public_path__ + "static/media/solarPannelDefault.d668c6f7.png";